import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7"
            height="5"
            viewBox="0 0 7 5"
            className={className}
        >
            <path d="M5.948 3.94a.338.338 0 01-.5 0L3.678 2.042a.238.238 0 00-.354 0L1.551 3.94a.338.338 0 01-.5 0 .39.39 0 010-.525l.037.034-.036-.034L3.25 1.06a.338.338 0 01.5 0l2.198 2.355a.39.39 0 010 .525zm0 0l-.036-.035.036.035z"></path>
        </svg>
    );
}
